import React, { useContext, useEffect, useState } from 'react';
import styles from './MainNavigation.module.scss';
import { DataContext } from '../../views/pages/Root';
import { addCustomPathToLink } from '../../functions';
import { Link } from 'react-router-dom';

const Logo = (_) => {
  const data = useContext(DataContext);
  const [logo, setLogo] = useState();
  const [hamburgerMenuIsActive, setHamburgerMenuIsActive] = useState(false);
  useEffect((_) => {
    setLogo(data?.staticData?.find((prop) => prop.name == 'headerLogo'));
  }, []);

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    const listener = () => {
      setScroll(window.scrollY > 100);
    };

    window.addEventListener('scroll', listener);
    return () => {
      window.removeEventListener('scroll', listener);
    };
  }, []);

  return (
    !!logo && (
      <Link
        to="https://katalog.leroymerlin.pl/magazyn/projekty-2025"
        className={`${styles.logo} ${scroll ? styles.smallLogo : styles.bigLogo}`}
        id="logoMenu"
      >
        <img className={styles.imageLogo} src={addCustomPathToLink(logo.image.src, true)} alt={logo.image.alt} />
      </Link>
    )
  );
};

export default Logo;
